/**
 * Defines BASE context object.
 */

// React imports.
import { createContext, useReducer } from "react";

// State context definition.
export const StateContext = createContext({
	formData: null,
	setFormData: () => null,
});

// Actions for state context.
export const STATE_ACTION_TYPES = {
	SET_FORM_DATA: "SET_FORM_DATA",
};

// State reducer definition.
const stateReducer = (state, action) => {
	const { type, payload } = action;

	switch (type) {
		case STATE_ACTION_TYPES.SET_FORM_DATA:
			return { ...state, formData: payload };

		default:
			throw new Error(`Unhandled type ${type} in stateReducer`);
	}
};

// State provider definition.
export const StateProvider = ({ children }) => {
	const [{ formData }, formDataDispatch] = useReducer(stateReducer, {
		formData: null,
	});

	const setFormData = (data) => {
		formDataDispatch({
			type: STATE_ACTION_TYPES.SET_FORM_DATA,
			payload: data,
		});
	};

	const value = {
		formData,
		setFormData,
	};

	return (
		<StateContext.Provider value={value}>{children}</StateContext.Provider>
	);
};
